export const mockSkuData = {
  "0001": [
    {
      lineNo: 1,
      item: "0001",
      poNumber: "PO-12345",
      description: "Wireless Keyboard K380",
      pack: "12",
      uom: "EA",
      expectedQty: 120,
      dispatchQty: 80
    },
    {
      lineNo: 2,
      item: "0001",
      poNumber: "PO-12346",
      description: "Wireless Keyboard K380",
      pack: "12",
      uom: "EA",
      expectedQty: 240,
      dispatchQty: 0
    },
    {
      lineNo: 3,
      item: "0001",
      poNumber: "PO-23456",
      description: "Wireless Keyboard K380",
      pack: "24",
      uom: "CS",
      expectedQty: 48,
      dispatchQty: 24
    }
  ],
  "0002": [
    {
      lineNo: 1,
      item: "0002",
      poNumber: "PO-34567",
      description: "Wireless Mouse M720",
      pack: "24",
      uom: "EA",
      expectedQty: 96,
      dispatchQty: 48
    },
    {
      lineNo: 2,
      item: "0002",
      poNumber: "PO-45678",
      description: "Wireless Mouse M720",
      pack: "48",
      uom: "CS",
      expectedQty: 192,
      dispatchQty: 0
    }
  ],
  "0003": [
    {
      lineNo: 1,
      item: "0003",
      poNumber: "PO-56789",
      description: "USB-C Hub Adapter",
      pack: "36",
      uom: "BX",
      expectedQty: 72,
      dispatchQty: 36
    },
    {
      lineNo: 2,
      item: "0003",
      poNumber: "PO-67890",
      description: "USB-C Hub Adapter",
      pack: "36",
      uom: "BX",
      expectedQty: 108,
      dispatchQty: 72
    },
    {
      lineNo: 3,
      item: "0003",
      poNumber: "PO-78901",
      description: "USB-C Hub Adapter",
      pack: "48",
      uom: "CS",
      expectedQty: 96,
      dispatchQty: 48
    }
  ],
  "0004": [
    {
      lineNo: 1,
      item: "0004",
      poNumber: "PO-89012",
      description: "Bluetooth Speaker",
      pack: "6",
      uom: "EA",
      expectedQty: 60,
      dispatchQty: 30
    },
    {
      lineNo: 2,
      item: "0004",
      poNumber: "PO-90123",
      description: "Bluetooth Speaker",
      pack: "12",
      uom: "CS",
      expectedQty: 36,
      dispatchQty: 12
    }
  ],
  "0005": [
    {
      lineNo: 1,
      item: "0005",
      poNumber: "PO-01234",
      description: "Wireless Charging Pad",
      pack: "12",
      uom: "EA",
      expectedQty: 48,
      dispatchQty: 0
    },
    {
      lineNo: 2,
      item: "0005",
      poNumber: "PO-23451",
      description: "Wireless Charging Pad",
      pack: "24",
      uom: "BX",
      expectedQty: 72,
      dispatchQty: 48
    },
    {
      lineNo: 3,
      item: "0005",
      poNumber: "PO-34512",
      description: "Wireless Charging Pad",
      pack: "36",
      uom: "PL",
      expectedQty: 108,
      dispatchQty: 72
    }
  ]
};

export const searchSkuData = (skuId) => {
  return mockSkuData[skuId] || [];
};
